// connectionReducer.js — S-D8 pure connection-state reducer (no JSX, no DOM).
//
// observeConsumer.js's disconnected()/rejected() are currently empty no-ops, so a mid-stream
// ActionCable drop freezes the chat silently and a rejected subscription shows nothing. This
// reducer maps connection lifecycle actions to a `connectionState` the UI renders as a chip:
//   'reconnecting' → subtle "Reconnecting…" (does NOT leave `working` hung)
//   'rejected'     → "Chat unavailable — refresh"
//   'connected'    → cleared (the existing replay(lastSeq) backfill re-mounts mid-stream replies)
//
// The integrator wires the observeConsumer callbacks + per-chat working-state to this; this
// module is intentionally ONLY the pure transition (node-testable).

export function connectionReducer(state, action) {
  switch (action) {
    case 'disconnected':
      return { ...state, connectionState: 'reconnecting' }
    case 'rejected':
      return { ...state, connectionState: 'rejected' }
    case 'connected':
      return { ...state, connectionState: 'connected' }
    default:
      return state
  }
}
